import { useMemo } from "react";

import { selectEnableOrganizationPlansPermission } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import type { OrganizationMemberPermissions } from "Api/organizations/member/Member.types";

export const permissions = {
  admin: "admin",
  billing: "billing",
  plans: "plans",
  members: "members",
  "projects:create": "projects:create",
  "projects:list": "projects:list"
} as const;

export type Permission = OrganizationMemberPermissions;

// This function is not connected to the redux store and should be used when we
// are sure that having all the permissions is not a problem and they can be
// filtered later on.
export const generateStaticPermissionsMap = <T>(initialValue: T) =>
  Object.fromEntries(
    Object.keys(permissions).map(permission => [permission, initialValue])
  ) as { [key in Permission]: T };

export const useAvailablePermissionsKeys = () => {
  const isPlansEnabled = useAppSelector(
    selectEnableOrganizationPlansPermission
  );

  const fitleredPermissions = useMemo(
    () =>
      Object.keys(permissions).filter(p => {
        if (!isPlansEnabled && p === permissions.plans) return false;
        return true;
      }) as Array<Permission>,
    [isPlansEnabled]
  );

  return [fitleredPermissions] as const;
};
